import script from "./AppTabMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppTabMenu.vue?vue&type=script&setup=true&lang=ts"

import "./AppTabMenu.vue?vue&type=style&index=0&id=3e888990&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e888990"]])

export default __exports__